export const inputEvent = 'change keydown paste input'